import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { resetPassword } from '../../api';

type ResetPasswordPageProps = {
  token: string;
};

function ResetPasswordPage({ token }: ResetPasswordPageProps) {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');

    if (password.length < 10) {
      setError('Password must be at least 10 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    if (!token) {
      setError('Reset token is missing. Please use the link from your email.');
      return;
    }

    setBusy(true);
    try {
      await resetPassword(token, password);
      setDone(true);
    } catch (err: any) {
      setError(err?.response?.data?.message || err?.message || 'Something went wrong. Please try again.');
    } finally {
      setBusy(false);
    }
  }

  if (!token) {
    return (
      <div className="authShell">
        <div className="authCard">
          <div className="authKicker">Invalid link</div>
          <h1>Reset link missing</h1>
          <p>This reset link is invalid. Please request a new one.</p>
          <button type="button" className="primaryButton authSubmit" onClick={() => navigate('/forgot-password')}>
            Request new link
          </button>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div className="authShell">
        <div className="authCard">
          <div className="authKicker">Password reset</div>
          <h1>Password updated</h1>
          <p>Your password has been reset. You can now sign in with your new password.</p>
          <button type="button" className="primaryButton authSubmit" onClick={() => navigate('/login')}>
            Sign in
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="authShell">
      <form className="authCard" onSubmit={handleSubmit}>
        <div className="authKicker">Cindro Admin</div>
        <h1>Set new password</h1>
        <p>At least 10 characters, with three of: lowercase, uppercase, numbers, symbols.</p>

        <label className="authField">
          <span>New password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
            autoFocus
            minLength={10}
          />
        </label>

        <label className="authField">
          <span>Confirm password</span>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder="••••••••"
            required
          />
        </label>

        {error ? <div className="authError">{error}</div> : null}

        <button type="submit" className="primaryButton authSubmit" disabled={busy || !password || !confirm}>
          {busy ? 'Saving…' : 'Set new password'}
        </button>
      </form>
    </div>
  );
}

export { ResetPasswordPage };
